import { CurrencyDisplay, ErrorDisplay } from '../../../shared/components'
import { SummaryData } from '../../../../../shared/types'

interface NetWorthSummaryProps {
  summaryData?: SummaryData
  isLoading?: boolean
  error?: Error | null
  onRetry?: () => void
}

export default function NetWorthSummary({ summaryData, isLoading = false, error, onRetry }: NetWorthSummaryProps) {
  if (isLoading) {
    return (
      <div className="net-worth-summary">
        <div className="total-net-worth loading">
          <div className="loading-placeholder">Loading...</div>
        </div>
        <div className="liquidity-summary">
          <div className="liquidity-card loading">
            <div className="loading-placeholder">Loading...</div>
          </div>
          <div className="liquidity-card loading">
            <div className="loading-placeholder">Loading...</div>
          </div>
          <div className="liquidity-card loading">
            <div className="loading-placeholder">Loading...</div>
          </div>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <ErrorDisplay 
        error={error} 
        title="Failed to Load Net Worth Data"
        showRetry={!!onRetry}
        onRetry={onRetry}
      />
    )
  }

  if (!summaryData) {
    return (
      <div className="net-worth-summary">
        <div className="total-net-worth">
          <div style={{ color: 'var(--text-muted)' }}>No data available</div>
        </div>
      </div>
    )
  }

  return (
    <>
      {/* Main Net Worth Display - matching HTML mockup structure */}
      <div className="total-net-worth positive">
        <CurrencyDisplay 
          value={summaryData.totalNetWorth} 
          className=""
        />
      </div>
      
      {/* Liquidity Breakdown Cards - matching HTML mockup structure */}
      <div className="liquidity-summary">
        <div className="liquidity-card">
          <div className="label">Total Liquid</div>
          <div className="value positive">
            <CurrencyDisplay 
              value={summaryData.totalLiquid} 
              className=""
            />
          </div>
        </div>
        
        <div className="liquidity-card">
          <div className="label">Total Semi-Liquid</div>
          <div className="value positive">
            <CurrencyDisplay 
              value={summaryData.totalSemiLiquid} 
              className=""
            />
          </div>
        </div>
        
        <div className="liquidity-card">
          <div className="label">Total Illiquid</div>
          <div className="value positive">
            <CurrencyDisplay 
              value={summaryData.totalIlliquid} 
              className=""
            />
          </div>
        </div>
      </div>
    </>
  )
}